// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"bc8a06b1","703":"fd368ca9","787":"6152f9e1"}[chunkId] + ".chunk.js";
};